$(document).ready(function() {
    var pathArray = window.location.pathname.split('/');
    var destination = '/';
    for (let i = 0; i < 5; i++) {
        switch(pathArray[i]) {
             case "collections":
                if (pathArray[i+1] == "all") {
                    destination = "/collections/volledig-assortiment";
                    window.location.href = destination;
                }
                break;
            case "products":
                if (i + 1 >= pathArray.length || typeof pathArray[i+1] === "undefined") {
                    destination = "/collections/volledig-assortiment";
                    window.location.href = destination;
                }
                break;
            case "contact":
                destination = "/pages/contacteer-ons";
                window.location.href = destination;
                break;
            case "contact-fr":
                destination = "/pages/contactez-nous";
                window.location.href = destination;
                break;
            case "contacto-pt":
                destination = "/pt-pt/pages/contate-nos";
                window.location.href = destination;
                break;
            case "contacto-es":
                destination = "/pages/contactanos";
                window.location.href = destination;
                break;
            case "contatto-it":
            case "contatti":
                destination = "/it/pages/contattaci";
                window.location.href = destination;
                break;
            case "kontakt-1":
                destination = "/pages/kontakt-os";
                window.location.href = destination;
                break;
            case "kontakt":
                destination = "/pages/kontaktieren-sie-uns";
                window.location.href = destination;
                break;    
            case "contact-en":
                destination = "/pages/contact-us";
                window.location.href = destination;
                break;
            case "liever-zonder-wifi":
            case "liever-zonder-wifi-it":
            case "preferisci-senza-wifi":
            case "preferisci-senza-wifi":
            case "liever-zonder-wifi-da":
            case "prefer-without-wifi":
            case "lieber-ohne-wlan":
                var filterParam = JSON.stringify( { attributes: { Sturing: ["Display"] }});
                var encodedFilterParam = encodeURIComponent(filterParam);
            case "liever-zonder-wifi":
            case "liever-zonder-wifi-da":
            case "prefer-without-wifi":
                destination = '/collections/automatische-zwembad-waterbehandeling-zwembadregeling-doseersysteem-zonder-wifi?filters=' + encodedFilterParam;
                window.location.href = destination;
                break;
            case "liever-zonder-wifi-it":
            case "preferisci-senza-wifi":
                destination = '/it/collections/trattamento-automatico-dell-acqua-della-piscina-regolazione-della-piscina-sistema-di-dosaggio-senza-wifi?filters=' + encodedFilterParam;
                window.location.href = destination;
                break;
            case "liever-zonder-wifi-pt":
                destination = '/pt-pt/collections/tratamento-automatico-da-agua-da-piscina-sistema-de-dosagem-de-controlo-da-piscina-sem-wifi?filters=' + encodedFilterParam;
                window.location.href = destination;
                break;
            case "lieber-ohne-wlan": 
                destination = '/collections/automatische-schwimmbad-wasseraufbereitung-schwimmbad-steuerung-dosiersystem-ohne-wlan?filters=' + encodedFilterParam;
                window.location.href = destination;
            default:
                break;
        }
    }
});